import { Modal, Button } from "antd";

export const HotelRulesModal = (props) => {
  const { isRulesModalVisible, hideHotelRulesModal, hotelRules } = props;
  return (
    <Modal
      title="Hotel Rules"
      visible={isRulesModalVisible}
      onCancel={hideHotelRulesModal}
      footer={
        <Button type="primary" onClick={hideHotelRulesModal}>
          Close
        </Button>
      }
    >
      {hotelRules ? (
        <div style={{ lineHeight: "1.8" }}>
          <p>
            <strong>Check-In Time:</strong> {hotelRules.checkInTimeFrom}
          </p>
          <p>
            <strong>Check-Out Time:</strong> {hotelRules.checkOutTimeBefore}
          </p>
          <p>
            <strong>Early Check-In Charge:</strong>{" "}
            {hotelRules.earlyCheckInCharge} VND
          </p>
          <p>
            <strong>Late Check-Out Charge:</strong>{" "}
            {hotelRules.lateCheckOutCharge} VND
          </p>
          <p>
            <strong>Smoking Rule:</strong>{" "}
            {hotelRules.smokingRule || "Not specified"}
          </p>
          <p>
            <strong>Pet Allowed:</strong> {hotelRules.petAllow ? "Yes" : "No"}
          </p>
          <p>
            <strong>Damage Compensation:</strong>{" "}
            {hotelRules.damageCompensation}
          </p>
          <p>
            <strong>Housekeeping Policy:</strong>{" "}
            {hotelRules.houseKeepingPolicy}
          </p>
          <p>
            <strong>No Show Charge:</strong> {hotelRules.noShowCharge}%
          </p>
          <p>
            <strong>Lost and Found Policy:</strong>{" "}
            {hotelRules.lostAndFoundPolicy}
          </p>
          <p>
            <strong>Refund Policy:</strong> {hotelRules.refundPolicy}
          </p>
          <p>
            <strong>Force Majeure Event:</strong> {hotelRules.forceMajeureEvent}
          </p>
          <p>
            <strong>Hotel Rule:</strong> {hotelRules.hotelRule}
          </p>
        </div>
      ) : (
        <p>Loading hotel rules...</p>
      )}
    </Modal>
  );
};
